import React, { useState, useEffect } from 'react';
import { Modal, Container, Card, Row } from 'react-bootstrap';
import { useAlert } from 'react-alert';
import './detailNew.css';
import '../../assets/css/Offcanvas.css';
import './popup.css';
import '../../assets/css/productDetail.css';
import './UpdtProPopup.css';
import variables from '../../Variables.json'

function NewPriceOfferPopup2({ show, onHide, productData, onYes, onNo, onNewPriceSubmit, acceptDisable, closeNotificationAndRefresh }) {
  const alert = useAlert();
  const [showPriceInput, setShowPriceInput] = useState(false);
  const [newPrice, setNewPrice] = useState('');
  const [marginError, setMarginError] = useState(false);
  const [selectedGst, setSelectedGst] = useState(productData?.taxClass || '18');
  const [currentCombination, setCurrentCombination] = useState();



  useEffect(() => {
    setCurrentCombination(productData?.currentCombination)
  }, [productData?.currentCombination])

  const handleYes = async () => {
    if (onYes) {
      await onYes(currentCombination);
    }
    // Close notification after accepting offer
    if (closeNotificationAndRefresh) {
      await closeNotificationAndRefresh('price');
    }
  };

  const handleNo = async () => {
    setShowPriceInput(true);
    // Close notification when rejecting offer
    if (closeNotificationAndRefresh) {
      await closeNotificationAndRefresh('price');
    }
  };

  const handleNewPriceSubmit = async () => {
    if (!newPrice || newPrice <= 0) {
      alert.error('Please enter a valid price');
      return;
    }

    if (onNewPriceSubmit) {
      await onNewPriceSubmit(newPrice);
      handleClose();
      // Close notification after submitting new price
      if (closeNotificationAndRefresh) {
        await closeNotificationAndRefresh('price');
      }
    } else {
      alert.error('Error: Submit function not available');
    }
  };

  const handleClose = () => {
    setShowPriceInput(false);
    setNewPrice('');
    setMarginError(false);
    setSelectedGst(productData?.taxClass || '18');
    setCurrentCombination(null)
    onHide();
  };

  const handlePriceChange = (e) => {
    setNewPrice(e.target.value);
    setMarginError(false);
  };

  // Don't render if productData is null
  if (!productData) {
    return null;
  }


  return (
    <Modal show={show} onHide={handleClose} centered size="md" className='newPriceOfferPopup'>
      <style>
        {`
          .newPriceOfferPopup .modal-content {
            border: none !important;
            border-radius: 12px !important;
            padding: 0 !important;
            overflow: hidden !important;
            box-shadow: 0 10px 30px rgba(0,0,0,0.2) !important;
          }
          .newPriceOfferPopup .modal-header {
            background: #3F8C8C !important;
            border: none !important;
            padding: 16px 20px !important;
          }
          .newPriceOfferPopup .modal-title {
            color: white !important;
            font-weight: 600 !important;
            font-size: 18px !important;
          }
          .newPriceOfferPopup .btn-close {
            filter: invert(1) !important;
          }
          .newPriceOfferPopup .modal-body {
            padding: 0 !important;
          }
          .price-comparison-card {
            background: #f8f9fa !important;
            border-radius: 8px !important;
            padding: 16px !important;
            margin: 8px !important;
          }
          .price-item {
            text-align: center !important;
          }
          .price-label {
            color: #6c757d !important;
            font-size: 12px !important;
            margin-bottom: 5px !important;
          }
          .price-value {
            font-size: 20px !important;
            font-weight: 700 !important;
            margin-bottom: 5px !important;
          }
          .price-gst {
            color: #6c757d !important;
            font-size: 12px !important;
          }
          .price-change {
            color: #3F8C8C !important;
            font-weight: 600 !important;
            font-size: 14px !important;
          }
          .message-box {
            background: #E0F2F1 !important;
            border: 1px solid #3F8C8C !important;
            border-radius: 6px !important;
            padding: 12px !important;
            margin: 10px !important;
            font-size: 14px !important;
            color: #333 !important;
          }
          .action-buttons {
            padding: 12px !important;
            display: flex !important;
            gap: 12px !important;
            justify-content: center !important;
          }
          .btn-reject {
            background: white !important;
            border: 1px solid #dee2e6 !important;
            color: #333 !important;
            border-radius: 6px !important;
            padding: 8px 16px !important;
            font-weight: 500 !important;
            font-size: 14px !important;
            min-width: 100px !important;
          }
          .btn-accept {
            background: #3F8C8C !important;
            border: none !important;
            color: white !important;
            border-radius: 6px !important;
            padding: 8px 16px !important;
            font-weight: 500 !important;
            font-size: 14px !important;
            min-width: 100px !important;
          }
          .trend-icon {
            color: #3F8C8C !important;
            font-size: 20px !important;
          }
          .newPriceOfferPopup input[type="number"]::placeholder {
            font-size: 14px !important;
            font-family: 'Open Sans', sans-serif !important;
            color: rgba(64, 57, 57, 0.5) !important;
          }
          
          /* Pushable Button Styling for Combinations */
          .enq-card-comb-div .pushable {
            margin: 4px !important;
            width: auto !important;
            min-width: 80px !important;
            height: auto !important;
          }
          
          .enq-card-comb-div .shadow {
            border-radius: 2px !important;
            background: hsl(0deg 0% 0% / 0.25) !important;
            transform: translateY(1px) !important;
          }
          
          .enq-card-comb-div .edge {
            border-radius: 2px !important;
            background: #3F8C8C !important;
          }
          
          .enq-card-comb-div .front {
            border-radius: 2px !important;
            background: #3F8C8C !important;
            transform: translateY(-1px) !important;
            padding: 6px 12px !important;
            font-size: 12px !important;
            font-weight: 600 !important;
            font-family: 'Poppins' !important;
          }
          
          .enq-card-comb-div .pushable:hover .front {
            transform: translateY(-2px) !important;
          }
          
          .enq-card-comb-div .pushable:hover .shadow {
            transform: translateY(2px) !important;
          }
          
          .enq-card-comb-div .pushable:active .front {
            transform: translateY(0px) !important;
          }
          
          .enq-card-comb-div .pushable:active .shadow {
            transform: translateY(1px) !important;
          }
          
          .enq-card-comb-div .pushable.selected .edge {
            background: #1a4d4d !important;
          }
          
          .enq-card-comb-div .pushable.selected .front {
            background: #1a4d4d !important;
          }

          #newPriceReqOfferBodyCntn{
            max-height: 500px;
            overflow-y: auto;
          }
        `}
      </style>
      <Modal.Header closeButton>
        <Modal.Title>New Price Offer</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!showPriceInput ? (
          <>
            {/* Product Information */}
            <div id='newPriceReqOfferBodyCntn'>
              <div style={{ padding: '12px 16px 0 16px' }}>
                <div style={{ color: '#6c757d', fontSize: '11px', marginBottom: '4px' }}>Product</div>
                <div style={{ color: '#333', fontSize: '14px', fontWeight: '600' }}>
                  {productData?.productName || productData?.name || 'Product Name'}
                </div>
              </div>

              {/* Price Comparison Card */}
              <div className="price-comparison-card">
                {/* Show current combination price info */}
                <div className="row">
                  <div className="col-4 price-item">
                    <div className="price-label">Current Price</div>
                    <div className="price-value text-black">
                      ₹ {currentCombination?.purchase_price || productData?.currentPrice || 'N/A'}
                    </div>
                    <div className="price-gst">(incl. {selectedGst}% GST)</div>
                  </div>
                  <div className="col-4 d-flex align-items-center justify-content-center">
                    <i className="fas fa-chart-line trend-icon"></i>
                  </div>
                  <div className="col-4 price-item">
                    <div className="price-label">New Offer</div>
                    <div className="price-value" style={{ color: '#3F8C8C' }}>
                      ₹ {currentCombination?.n_purchase_price || productData?.newPrice || 'N/A'}
                    </div>
                    <div className="price-gst">(incl. {selectedGst}% GST)</div>
                  </div>
                </div>
              </div>

              {/* Message Box */}
              <div className="message-box">
                From Toolsvilla: This is a new transfer price offer for <strong>{currentCombination?.cmb || 'this configuration'}</strong>. Please review and accept.
              </div>

            </div>

            {/* Action Buttons */}
            <div className="action-buttons">
              <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', width: '100%' }}>
                <button
                  className="btn btn-reject"
                  onClick={handleNo}
                  style={{
                    flex: 1,
                    maxWidth: '150px'
                  }}
                >
                  Reject
                </button>
                <button
                  className="btn btn-accept"
                  onClick={handleYes}
                  disabled={acceptDisable}
                  style={{
                    flex: 1,
                    maxWidth: '150px'
                  }}
                >
                  Accept Offer
                </button>
              </div>
            </div>
          </>
        ) : (
          <div style={{ padding: '20px' }}>
            <div className="text-center mb-3">
              <div id='newPriceReqOfferBodyCntn'>
                <h5 className="mb-2" style={{ color: '#333', fontWeight: '600' }}>
                  New Price Request
                  <br />
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    style={{
                      width: 'auto',
                      minWidth: '80px',
                      height: 'auto',
                      margin: '4px',
                      marginTop: '10px'
                    }}
                  >
                    <span style={{
                      background: '#1a4d4d',
                      padding: '6px 12px',
                      fontSize: '12px',
                      fontWeight: '600',
                      fontFamily: 'Poppins',
                      minWidth: '80px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '4px',
                      color: 'white'
                    }}>
                      <i className="bi bi-check-circle-fill" style={{
                        fontSize: '12px',
                        color: '#4ade80'
                      }}></i>
                      {currentCombination?.cmb}
                    </span>
                  </button>
                </h5>
                <div className="mb-3">
                  <span className="text-muted small">
                    Current Transfer Price (incl. {productData?.taxClass || '18'}% GST) :
                  </span>
                  <span className="f-600 fs-13 ms-1 mt-1 text-black ff_pop">
                    ₹ {currentCombination?.purchase_price || productData?.currentPrice || 'N/A'}
                  </span>
                </div>
                <div className="mb-3">
                  <span className="text-muted small">Please Enter New Transfer Price :</span>
                </div>
                <div className="d-flex justify-content-center align-items-center mb-3">
                  <span className="me-2" style={{ fontSize: '14px' }}>₹</span>
                  <input
                    type="number"
                    className="form-control"
                    value={newPrice}
                    onChange={handlePriceChange}
                    placeholder="Enter new price"
                    style={{
                      height: '32px',
                      maxWidth: '200px',
                      fontSize: '14px',
                      fontFamily: 'Open Sans, sans-serif'
                    }}
                  />
                </div>

                {/* GST Section */}
                <div className="mb-3">
                  <div className="text-center mb-2">
                    <span className="text-muted small">GST :</span>
                  </div>
                  <div className="d-flex justify-content-center align-items-center">
                    <i
                      className="bi bi-percent me-2"
                      aria-hidden="true"
                      style={{
                        fontSize: '14px',
                        // fontWeight: '500'
                      }}
                    ></i>
                    <select
                      className="form-control"
                      value={selectedGst}
                      onChange={(e) => setSelectedGst(e.target.value)}
                      style={{
                        height: '32px',
                        maxWidth: '200px',
                        fontSize: '14px',
                        fontFamily: 'Open Sans, sans-serif'
                      }}
                    >
                      {variables?.variables?.gstValues.map((item, index) => {
                        return (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        );
                      })}                    </select>
                  </div>
                </div>
              </div>

              <div className="mt-3">
                <button
                  className="btn px-4"
                  onClick={handleNewPriceSubmit}
                  style={{
                    borderRadius: '6px',
                    background: '#3F8C8C',
                    border: 'none',
                    color: 'white',
                    fontWeight: '500'
                  }}
                >
                  SUBMIT
                </button>
              </div>
            </div>
          </div>
        )}

      </Modal.Body>
    </Modal>
  );
}

export default NewPriceOfferPopup2;